module.exports = __webpack_public_path__ + "img/cafesaula.bda36725.jpg";